import I18N from '@leverege/i18n'

const { t } = I18N.ns( 'ps.Constants' )

export default {
  GRAPH_HEIGHT : 248,
  CAR_MINIMUM_CONFIDENCE : 0,
  LIFT_UTIL_MINIMUM_CONFIDENCE : 0,
  JACK_MINIMUM_CONFIDENCE : 0,
  LIFT_MINIMUM_CONFIDENCE : 0,
  SEVEN_DAYS_IN_MS : 1000 * 60 * 60 * 24 * 7,
  LEAD_TIME_MAX_MS : Infinity, // 60 * 60 * 1000 // 20 * 60 * 1000
  ONE_HOUR : 1000 * 60 * 60,
  get DAYS_OF_WEEK() {
    return [
      t( 'monday' ),
      t( 'tuesday' ),
      t( 'wednesday' ),
      t( 'thursday' ),
      t( 'friday' ),
      t( 'saturday' ),
      t( 'sunday' ),
    ]
  },
  GRID_SIZE : {
    width : 480,
    height : 270
  },
  HEATMAP_IMAGE_SIZE : {
    thumbnail : {
      height : 250,
      width : 444
    },
    original : {
      height : 1080,
      width : 1920
    }
  },
  SHELF_MONITORING_IMAGE_SIZE : {
    segment : {
      original : {
        width : 3000,
        height : 4500
      },
      thumbnail : {
        width : 200,
        height : 300
      }
    },
    pog : {
      original : {
        width : 388,
        height : 621
      },
      thumbnail : {
        width : 200,
        height : 300
      }
    }
  },
  SHELF_MONITORING_ALERT_TYPES : {
    inventoryHole : {
      value : 'Inventory Hole',
      variant : 'tablePillAlert|pillAlert'
    }
  }
}
